export default {
  bindSample({ babyId, payload = {} }) {
    return this.http(
      'HealthTask',
      'put',
      `/api/v1/babies/${babyId}/bind_code`,
      payload
    );
  },

  getBoundSamples() {
    return this.http('GENE_BIND', 'get', '/api/v1/bar_code/lists');
  },

  getBabyBoundSamples(id) {
    return this.http(
      'HealthTask',
      'get',
      `/api/v1/babies/${id}/bar_codes`
    );
  },

  getBabyProfile(id) {
    return this.http('HealthTask', 'get', `/api/v1/babies/${id}`);
  },

  // 根据token查询用户信息
  queryInfo(params) {
    return this.http('HealthTask', 'get', '/api/v1/users/profile', params);
  },

  getUserProfile(params) {
    return this.queryInfo(params);
  },

  // 查询历史基因搜索记录
  queryGeneSearchHistory() {
    return this.http('GENE_BIND', 'get', '/api/v1/search_histories');
  },
  // 搜索基因
  searchGene(data) {
    return this.http(
      'GENE_BIND',
      'get',
      '/api/v1/gene_result/search',
      data
    );
  },
  // 清除搜索记录
  cleanSearchHistory() {
    return this.http('GENE_BIND', 'post', '/api/v1/search_histories/delete', {
      del_type: 'all'
    });
  },
  // 首次检测失败时，发送优惠券
  sendGeneCoupon({ qs = {} }) {
    return this.http('GENE_BIND', 'post', '/api/v1/coupon/send', qs);
  },
  // 查询barcode状态，根据barcode跳转绑定页，成功页，样本状态页，检测报告页，检测失败页
  queryBarCode({ qs = {} }) {
    return this.http('GENE_BIND', 'get', '/api/v1/bar_code/status', qs);
  },
  // 校验barcode是否有效
  postBarCode(data) {
    return this.http('GENE_BIND', 'post', '/api/v1/bind_code/check', data);
  },

  // 绑定barcode和用户信息
  bindBarCode(data) {
    return this.http('GENE_BIND', 'post', '/api/v1/bind_codes', data);
  },
  // 创建寄送地址
  createAddress(data) {
    return this.http('GENE_BIND', 'post', '/api/v1/present/create', data);
  },
  // 确认寄送信息
  makeAppointment(id) {
    return this.http('GENE_BIND', 'post', `/api/v1/present/confirm/${id}`);
  },
  // 更新寄送信息
  newAddress(id, data) {
    return this.http(
      'GENE_BIND',
      'post',
      `/api/v1/present/update/${id}`,
      data
    );
  },
  // 样本状态页时间查询
  queryBarCodeDate(qs) {
    return this.http(
      'GENE_BIND',
      'get',
      '/api/v1/bar_code_states/history',
      qs
    );
  },
  // 样本状态回寄信息查询
  querySendMessage({ qs = {} }) {
    return this.http('GENE_BIND', 'get', '/api/v1/present/show', qs);
  },
  // 检测报告首页
  queryReport(querys) {

    return this.http(
      'GENE_BIND',
      'get',
      '/api/v1/bar_code/categories',
      querys
    );
  },
  // 检测报告首页小卡片
  geneScience() {
    return this.http('GENE_BIND', 'get', '/api/v1/gene_cards');
  },
  // 检测报告二级页面
  querySecond(id = 0, qs = {}) {
    return this.http(
      'GENE_BIND',
      'get',
      `/api/v1/category/${id}/second_categories`,
      qs
    );
  },
  // 检测报告结果页
  queryResult(id, qs) {
    return this.http(
      'GENE_BIND',
      'get',
      `/api/v1/bar_code_result/${id}/detail`,
      qs
    );
  },
  // 检测报告科学细节页
  queryDetail(id, qs) {
    return this.http(
      'GENE_BIND',
      'get',
      `/api/v1/bar_code_result/${id}/science`,
      qs
    );
  },
  // 评价检测报告
  postHealthEvaluate(id, data) {
    return this.http(
      'GENE_BIND',
      'post',
      `/api/v1/bar_code_result/${id}/evaluate`,
      data
    );
  },
  // 重新绑定采集器
  rebind(data) {
    return this.http('GENE_BIND', 'post', '/api/v1/rebind_codes', data);
  },
  getGeneLevelList(data) {
    return this.http('GENE_BIND', 'get', '/api/v1/gene_result/list', data);
  },
  unbind(data) {
    return this.http('GENE_BIND', 'post', '/api/v1/bar_code/remove', data);
  },
  getFaq() {
    return this.http('GENE_BIND', 'get', '/api/v1/questions');
  },
  getBabyInfoByBarcode(data) {
    return this.http(
      'GENE_BIND',
      'get',
      '/api/v1/bar_code/baby_info',
      data
    );
  }
};
